const normalisedLobIcons = {
    PA: {
        image: 'personal-auto',
     //   font: 'mi-directions_car'
        font: 'fas fa-car-alt',  
        banner: 'banner-vehicle.jpg'
    },
    HO: {
        image: 'home-owners',
      //  font: 'mi-home'
        font: 'fas fa-home',
        banner: 'banner-residential.jpg'
    },
    GL: {
        image: 'general-liability',
        font: 'mi-healing',
        banner: 'banner-vehicle.jpg'
    },
    BO: {
        image: 'business-owners',
        // font: 'mi-store'
        font: 'fas fa-shopping-bag'
    },
    IM: { 
        image: 'inland-marine',  
        font: 'fas fa-anchor',
        banner: 'banner-marine.jpg'
      //  font: 'fa-ship'
    },
    CP: {
        image: 'commercial-property',
        font: 'fas fa-shopping-bag',
        banner: 'banner-commercialProperty.jpg'
    },
    CA: {
        image: 'commercial-auto',
        font: 'fas fa-shipping-fast', 
        banner: 'banner-vehicle.jpg'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work',
        banner: 'banner-vehicle.jpg'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'fas fa-shopping-bag'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon', 
        font: 'fas fa-umbrella',
        banner: 'banner-umbrella.jpg'
    },
    BP7: {
        image: 'farm',
        font: 'fas fa-tractor',  //<i class="fas fa-tractor"></i>
       //  font: 'fa-leaf',
        banner: 'banner-farm.jpg'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt',
        banner: 'banner-vehicle.jpg'
    }
};

// const materialLobIcons = {
//     PA: {
//         image: 'personal-auto',
//         //font: 'mi-directions_car'
//         font: 'fa_car'
//     },
//     HO: {
//         image: 'home-owners',
//       //  font: 'mi-home'
//         font: 'fa-home'
//     },
//     GL: {
//         image: 'general-liability',
//         font: 'mi-healing'
//     },
//     BO: {
//         image: 'business-owners',
//         font: 'mi-business'
//     },
//     IM: {
//         image: 'inland-marine',
//         font: 'mi-directions_boat'
//     },
//     CP: {
//         image: 'commercial-property',
//         font: 'mi-apartment'
//     },
//     CPKG: {
//         image: 'commercial-package',
//         font: 'mi-unarchive'
//     },
//     CA: {
//         image: 'commercial-auto',
//         font: 'mi-local-shipping'
//     },
//     WC: {
//         image: 'workers-comp',
//         font: 'mi-work'
//     },
//     TRVL: {
//         image: 'travel',
//         font: 'mi-plane'
//     },
//     PUL: {
//         image: 'no-icon',
//         font: 'fa-umbrella'
//     },
//     default: {
//         image: 'no-icon', // Using an existing empty image as default to avoid 404s
//         font: 'mi-receipt'
//     }
// };

const lobKeys = {
    PersonalAuto: 'PA',
    PersonalAutoLine: 'PA',
    auto_per: 'PA',
    Homeowners: 'HO',
    homeowners: 'HO',
    HomeOwners: 'HO',
    HomeownersLine_HOE: 'HO',
    HomeownersLine: 'HO',
    HOPLine: 'HO',
    HOLine: 'HO',
    HOPHomeowners: 'HO',
    GeneralLiability: 'GL',
    GeneralLiabilityLine: 'GL',
    GLLine: 'GL',
    Businessowners: 'BO',
    BusinessOwners: 'BO',
    BusinessOwnersLine: 'BO',
    BOPLine: 'BO',
    HOPBoat_EY: 'IM',
    InlandMarine: 'IM',
    InlandMarineLine: 'IM',
    IMLine: 'IM',
    CommercialProperty: 'CP',
    CommercialPropertyLine: 'CP',
    CPLine: 'CP',
    CommercialAuto: 'CA',
    BusinessAuto: 'CA',
    BusinessAutoLine: 'CA',
    WorkersComp: 'WC',
    WorkersCompLine: 'WC',
    WC7WorkersComp: 'WC',
    CommercialPackage: 'CPKG',
    CommercialPackageLine: 'CPKG',
    travel_perLine: 'TRVL',
    PersonalUmbrellaLine: 'PUL',
    PersonalUmbrella: 'PUL',
    BP7Line: 'BP7',
    BP7BusinessOwners: 'BP7'    
};

const lobProductNameKeys = {
    'Personal Auto': 'PA',
    'Commercial Auto': 'CA',
    'Residential': 'HO',
    'Farm': 'BP7',
    'Umbrella': 'PUL',    
    'Marine': 'PA',
    'Commercial Property': 'CP'
}

const getNormalisedObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || lobProductNameKeys[lobCode] || 'default';
    return normalisedLobIcons[normalisedKey];
};

const applicationPages = {
    DASHBOARD: {
        banner: 'banner-dashboard.jpg'
    },
    CLAIMDETAILS: {
        banner: 'banner-faq.jpg'
    },
    MYDOCUMENTS: {
        banner: 'banner-documents.jpg'
    },
    FAQ: {
        banner: 'banner-faq.jpg'
    },
    MYCLAIMS: { 
        banner: 'banner-claim-listing.jpg'
    },
    MYBILLING: {
        banner: 'banner-documents.jpg'
    },
    default: {
        banner: 'banner-dashboard.jpg'
    }
};

// const getMaterialObject = (lobCode) => {
//     const normalisedKey = lobKeys[lobCode] || 'default';
//     return materialLobIcons[normalisedKey];
// };

// const getImageIcon = (lobCode) => {
//     return getNormalisedObject(lobCode).image;
// };

// const getFontIcon = (lobCode) => {
//     return getNormalisedObject(lobCode).font;
// };

// const getMaterialIcon = (lobCode) => {
//     return getMaterialObject(lobCode).font;
// };

// export default {
//     getImageIcon: getImageIcon,
//     getFontIcon: getFontIcon,
//     getMaterialIcon: getMaterialIcon
// };
export function getBannerImage(lobCode){
    return getNormalisedObject(lobCode).banner;
}

export function getFontIcon(lobCode){
    return getNormalisedObject(lobCode).font;
}

export function getPageHeaderImage(pageName){
    let page = pageName? pageName.toUpperCase() : 'default';
    return applicationPages[page].banner;
}
